import React from 'react';
import { ConnectionType, IConnectionDetailsDTO } from '../../../../../../api/connections.dao';
import { ZoomConnectionDetailsPopoverContent } from './zoom-connection-details-popover-content';
import { WebexConnectionDetailsPopoverContent } from './webex-connection-details-popover-content';
import { TeamsConnectionDetailsPopoverContent } from './teams-connection-details-popover-content';
import { BluejeansConnectionDetailsPopoverContent } from './bluejeans-connection-details-popover-content';
import { KnovioConnectionDetailsPopoverContent } from './knovio-connection-details-popover-content';
import { OtherConnectionDetailsPopoverContent } from './other-connection-details-popover-content';
import { InPersonConnectionDetailsPopoverContent } from './in-person-connection-details-popover-content';
import { ShowcaseConnectionDetailsPopoverContent } from './showcase-connection-details-popover-content';
import { WebinarConnectionDetailsPopoverContent } from './webinar-connection-details-popover-content';
import { WebinarReportsViewModel } from '../../webinar-report/webinar-reports.viewmodel';
import { VeracastConnectionDetailsPopoverContent } from './veracast-connection-details-popover-content';
import { AudioBridgeConnectionDetailsPopoverContent } from './audiobridge-connection-details-popover-content';
import { PanelistLinkConnectionDetailsPopoverContent } from './panelistlink-connection-details-popover-content';

type ConnectionDetailsPopoverContentProps = {
    connection: IConnectionDetailsDTO;
    onLinkClick: (url: string) => void;
    onClickTroubleshoot: () => void;
    onCopyBtnClick: () => void;
    onOpenKnovioPreviewLinkPopover: () => void;
    webinarReportsVM: WebinarReportsViewModel;
    audioProviderLabel?: string;
};

export const ConnectionDetailsPopoverContent = (props: ConnectionDetailsPopoverContentProps): JSX.Element => {
    const {
        connection,
        onLinkClick,
        onClickTroubleshoot,
        onCopyBtnClick,
        onOpenKnovioPreviewLinkPopover,
        webinarReportsVM,
        audioProviderLabel = ''
    } = props;

    switch (connection.type) {
        case ConnectionType.Zoom:
            return <ZoomConnectionDetailsPopoverContent
                connection={connection}
                onLinkClick={onLinkClick}
                onClickTroubleshoot={onClickTroubleshoot}
                onCopyBtnClick={onCopyBtnClick}
            />;
        case ConnectionType.Webex:
            return <WebexConnectionDetailsPopoverContent connection={connection} onLinkClick={onLinkClick} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.Teams:
            return <TeamsConnectionDetailsPopoverContent connection={connection} onLinkClick={onLinkClick} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.Bluejeans:
            return <BluejeansConnectionDetailsPopoverContent connection={connection} onLinkClick={onLinkClick} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.Knovio:
            return <KnovioConnectionDetailsPopoverContent
                connection={connection}
                onCopyBtnClick={onCopyBtnClick}
                onOpenKnovioPreviewLinkPopover={onOpenKnovioPreviewLinkPopover}
            />;
        case ConnectionType.Other:
            return <OtherConnectionDetailsPopoverContent connection={connection} onLinkClick={onLinkClick} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.InPerson:
            return <InPersonConnectionDetailsPopoverContent connection={connection} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.Showcase:
            return <ShowcaseConnectionDetailsPopoverContent connection={connection} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.Webinar:
            return <WebinarConnectionDetailsPopoverContent
                connection={connection}
                onLinkClick={onLinkClick}
                onClickTroubleshoot={onClickTroubleshoot}
                onCopyBtnClick={onCopyBtnClick}
                webinarReportsVM={webinarReportsVM}
            />;
        case ConnectionType.Veracast:
            return <VeracastConnectionDetailsPopoverContent connection={connection} onLinkClick={onLinkClick} onCopyBtnClick={onCopyBtnClick} />;
        case ConnectionType.AudioBridge:
            return <AudioBridgeConnectionDetailsPopoverContent
                connection={connection}
                onLinkClick={onLinkClick}
                onCopyBtnClick={onCopyBtnClick}
                audioProviderLabel={audioProviderLabel}
            />;
        case ConnectionType.PanelistLink:
            return <PanelistLinkConnectionDetailsPopoverContent
                connection={connection}
                onLinkClick={onLinkClick}
                onCopyBtnClick={onCopyBtnClick}
            />;
        default:
            return <></>;
    }
};
